// Use client is needed here because the Theme is being used.
'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeProvider } from 'styled-components';
import { useTheme, useUpdateThemeWithFontBrightness, } from '@design-system/theme';
import { WrapperContentStyled } from './styled';
export const ContentWrapper = ({ children, }) => {
    const theme = useTheme();
    const updatedTheme = useUpdateThemeWithFontBrightness(theme, theme.themeVariables.frameFontBrightness);
    return (_jsx(ThemeProvider, { theme: updatedTheme, children: _jsx(WrapperContentStyled, { bg: theme.themeVariables.frameBackgroundColor, children: children }) }));
};
//# sourceMappingURL=ContentWrapper.js.map